import React, { useState } from "react";
import { ArrowRight } from "lucide-react";

export default function TimerControls({
  running,
  timerSeconds,
  handleStart,
  handleStop,
  handleReset,
  handleNextTimer,
  theme,
  mode,
}) {
  const logoBg = theme.colors.logoBackground;
  const logoText = theme.colors.logoText;
  const [hovered, setHovered] = useState(false);

  return (
    <div className="flex justify-center gap-4 mt-4">
      {!running ? (
        <button
          onClick={handleStart}
          disabled={mode !== "stopwatch" && timerSeconds === 0}
          style={{
            backgroundColor: logoBg,
            color: logoText,
            opacity: mode !== "stopwatch" && timerSeconds === 0 ? 0.5 : 1,
            cursor: mode !== "stopwatch" && timerSeconds === 0 ? "not-allowed" : "pointer",
          }}
          className="font-bold py-2 px-6 rounded-xl shadow hover:opacity-90 transition"
        >
          Start
        </button>
      ) : (
        <button
          onClick={handleStop}
          style={{
            backgroundColor: logoBg,
            color: logoText,
          }}
          className="font-bold py-2 px-6 rounded-xl shadow hover:opacity-90 transition"
        >
          Stop
        </button>
      )}

      <button
        onClick={handleReset}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          borderColor: logoBg,
          color: hovered ? logoText : logoBg,
          backgroundColor: hovered ? logoBg : "transparent",
          transition: "all 0.2s ease-in-out",
        }}
        className="border-2 font-bold py-2 px-6 rounded-xl"
      >
        Reset
      </button>

      {/* --- Next Timer Button --- */}
{(mode === "preset" || mode === "custom") && (
  <button
    onClick={handleNextTimer}
    style={{
      backgroundColor: "transparent",
      color: logoBg,
      border: `2px solid ${logoBg}`,
      borderRadius: "1rem",
      padding: "0.5rem 1.2rem",
      marginLeft: "0.25rem",
      fontWeight: 600,
      fontSize: "1.7rem",
      display: "flex",
      alignItems: "center",
      transition: "background 0.15s, color 0.15s, border 0.15s",
    }}
    className="hover:bg-zinc-100 hover:text-black"
    title="Skip to Next Timer"
  >
    <ArrowRight size={22} />
    </button>
    )}
    </div>
  );
}
